import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.16699 14.1673H5.83366C4.68088 14.1673 3.69824 13.7611 2.88574 12.9486C2.07324 12.1361 1.66699 11.1534 1.66699 10.0007C1.66699 8.84787 2.07324 7.86523 2.88574 7.05273C3.69824 6.24023 4.68088 5.83398 5.83366 5.83398H9.16699V7.50065H5.83366C5.13921 7.50065 4.54894 7.74371 4.06283 8.22982C3.57671 8.71593 3.33366 9.30621 3.33366 10.0007C3.33366 10.6951 3.57671 11.2854 4.06283 11.7715C4.54894 12.2576 5.13921 12.5007 5.83366 12.5007H9.16699V14.1673ZM6.66699 10.834V9.16732H13.3337V10.834H6.66699ZM10.8337 14.1673V12.5007H14.167C14.8614 12.5007 15.4517 12.2576 15.9378 11.7715C16.4239 11.2854 16.667 10.6951 16.667 10.0007C16.667 9.30621 16.4239 8.71593 15.9378 8.22982C15.4517 7.74371 14.8614 7.50065 14.167 7.50065H10.8337V5.83398H14.167C15.3198 5.83398 16.3024 6.24023 17.1149 7.05273C17.9274 7.86523 18.3337 8.84787 18.3337 10.0007C18.3337 11.1534 17.9274 12.1361 17.1149 12.9486C16.3024 13.7611 15.3198 14.1673 14.167 14.1673H10.8337Z",
		fill: "#636566"
	})]
});
const ForwardRef = forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
